import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useOptimizelyContext, OptimizelyVariation } from "./..";
export var OptimizelyExperiment = function OptimizelyExperiment(_ref) {
  var children = _ref.children,
    experimentId = _ref.experimentId,
    onVariationDecided = _ref.onVariationDecided;
  var _experiments$experime;
  validateChildren(children);
  var isExperimentActivated = useRef(false);
  var experimentToActivate = useRef(false);
  var defaultVariation = React.Children.toArray(children).find(function (c) {
    var _c$props;
    return c === null || c === void 0 ? void 0 : (_c$props = c.props) === null || _c$props === void 0 ? void 0 : _c$props.default;
  });
  if (!defaultVariation) {
    throw new Error("OptimizelyExperiment (".concat(experimentId, "): a default OptimizelyVariation is required"));
  }
  var _useOptimizelyContext = useOptimizelyContext(),
    experiments = _useOptimizelyContext.experiments,
    experimentsToActivate = _useOptimizelyContext.experimentsToActivate,
    activateExperiment = _useOptimizelyContext.activateExperiment;
  useEffect(function () {
    /* Experiments eligible for activation */
    if (experimentsToActivate) {
      if (!isExperimentActivated.current && experimentToActivate.current) {
        var _experimentsToActivat;
        var _experimentToActivate = experimentToActivate.current,
          expId = _experimentToActivate.experimentId,
          variationId = _experimentToActivate.variationId;
        if ((experimentsToActivate === null || experimentsToActivate === void 0 ? void 0 : (_experimentsToActivat = experimentsToActivate[expId]) === null || _experimentsToActivat === void 0 ? void 0 : _experimentsToActivat.variationId) === variationId) {
          isExperimentActivated.current = true;
          activateExperiment(experimentToActivate.current);
        }
      }
    }
  }, [activateExperiment, experimentsToActivate]);
  var experiment = (_experiments$experime = experiments === null || experiments === void 0 ? void 0 : experiments[experimentId]) !== null && _experiments$experime !== void 0 ? _experiments$experime : null;
  if (experiment) {
    var variationId = experiment.variationId;
    var variation = React.Children.toArray(children).find(function (c) {
      var _c$props2;
      return (c === null || c === void 0 ? void 0 : (_c$props2 = c.props) === null || _c$props2 === void 0 ? void 0 : _c$props2.variationId) === variationId;
    });
    if (variation) {
      onVariationDecided(experiment);
      if (!isExperimentActivated.current) {
        experimentToActivate.current = _objectSpread({
          experimentId: experimentId
        }, experiment);
      }
      return variation;
    }
  }
  onVariationDecided(defaultVariation.props.variationId);
  return defaultVariation;
};
OptimizelyExperiment.propTypes = {
  children: function children(props) {
    return React.Children.forEach(props.children, validateChild);
  },
  experimentId: PropTypes.string.isRequired,
  onVariationDecided: PropTypes.func
};
OptimizelyExperiment.defaultProps = {
  children: null,
  onVariationDecided: function onVariationDecided() {}
};
function validateChild(child) {
  if ((child === null || child === void 0 ? void 0 : child.type) !== OptimizelyVariation) {
    // eslint-disable-next-line no-console
    console.warn('OptimizelyExperiment: children should be only of type OptimizelyVariation.');
  }
}
function validateChildren(children) {
  React.Children.forEach(children, validateChild);
}
OptimizelyExperiment.displayName = 'OptimizelyExperiment';